import {Injectable, Input } from '@angular/core';
import {DataService} from '../../shared/services/data.service';
import {StorageService} from '../../shared/services/storage.service'
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';
import { Result } from 'src/app/shared/model/response.model';
import { PaginationBaseModel, TablePaginationModel, ManagerListStatusModel, MailingListIds } from 'src/app/shared/components/ag-grid/ag-grid.model';
import { AddSnippet, Id, updateSnippet } from 'src/app/shared/model/snippet.model';
@Injectable({
    providedIn: 'root'
  })
  export class ListManagerService {
    selectionChanged = new Subject();
    public id:string='';
    public statusUpdate = new BehaviorSubject(undefined);
    @Input() insertSnippetModel = new AddSnippet();
    
    constructor(public service:DataService) { }



     getAllManagerList(getAllMailingList:PaginationBaseModel){
      let url = "smxEmailPlatform/MailingList/getAllMailingList";
      return this.service.post(url, getAllMailingList).pipe<Result>(tap((response: any) => {
      return response;
      })
      );
    }
    getAllManagerListDetails(getAllMailingListDetails:TablePaginationModel){
      let url = "smxEmailPlatform/MailingList/getAllMailingListDetails";
      return this.service.post(url, getAllMailingListDetails).pipe<Result>(tap((response: any) => {
      return response;
      })
      );
    }

    managerListStatusUpdate(statusUpdateData:ManagerListStatusModel){
      let url = "smxEmailPlatform/MailingList/StatusUpdate";
      return this.service.post(url, statusUpdateData).pipe<Result>(tap((response: any) => {
      return response;
      })
      );
    }
    deleteManagerList(id: MailingListIds ): Observable<Result> {
      let url = "smxEmailPlatform/MailingList/deleteMailingList";
      return this.service.post(url, id).pipe<Result>( tap((response: any) => {
          return response;
        })
      );
    }
    deletemanagerListDetails(id: any ): Observable<Result> {
      let url = "smxEmailPlatform/MailingList/deleteListDetails";
      return this.service.post(url, id).pipe<Result>( tap((response: any) => {
          return response;
        })
      );
    }

    addSnippet(insertSnippetModel:AddSnippet) : Observable<Result>{
      let url = "smxEmailPlatform/EmailTemplate/addSnippet";
      const myjson = JSON.stringify(insertSnippetModel);
      console.log("add update company json........",myjson)
      return this.service.post(url, insertSnippetModel, true).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }

    getAllSnippetList(getAllSnippetList:PaginationBaseModel){
      let url = "smxEmailPlatform/EmailTemplate/getallSnippetlist";
      return this.service.post(url, getAllSnippetList).pipe<Result>(tap((response: any) => {
      return response;
      })
      );
    }


    SnippetUpdate(data: updateSnippet): Observable<Result> {
      let url = "smxEmailPlatform/EmailTemplate/updateSnippet";
      return this.service.post(url, data).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }

    getsnippetById(Id:string): Observable<Result> {
      let url = `smxEmailPlatform/EmailTemplate/getsnippetbyid=${Id}`;
      return this.service.get(url, true).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }

    deleteSnippetlist(id:any): Observable<Result> {
      let url = `smxEmailPlatform/EmailTemplate/deleteSnippet?Id=${id}`;
      return this.service.delete(url, true).pipe<Result>( tap((response: any) => {
          return response;
        })
      );
    }
  

  }
